import React, { Component } from 'react'
import { Table } from 'antd'
import { observer } from "mobx-react"
import styled from 'styled-components'

const FileIdText = styled.div`
  color: #286cac;
  cursor: pointer;
`

@observer
class SampleResult extends Component {
  render() {
    const {
      onOpenCopyDetail,
      store: { detailData: { inforStats } }
    } = this.props

    const columns = [
      {
        title: 'File_ID',
        dataIndex: 'fileId',
        render: (text, record) => {
          return (
            <FileIdText
              onClick={() => onOpenCopyDetail(record.fileId)}
            >
              {text}
            </FileIdText>
          )
        }
      },
      {
        title: 'Sample_Name',
        dataIndex: 'sampleName',
      },
      {
        title: 'Call_Rate',
        dataIndex: 'callRate',
      },
      {
        title: 'Total_SNP',
        dataIndex: 'totalSNP',
      },
      {
        title: 'Coverage',
        dataIndex: 'coverage',
      },
      {
        title: 'Coverage_Y',
        dataIndex: 'coverageY',
      },
      {
        title: 'SD',
        dataIndex: 'sd',
      },
      {
        title: 'PASS',
        dataIndex: 'pass'
      }
    ]
    return (
      <Table
        columns={columns}
        dataSource={inforStats ? inforStats.slice() : []}
        rowKey={record => record.fileId}
        pagination={false}
      />
    )
  }
}

export default SampleResult


// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/haplotypeReport/containers/SampleResult.js